import { render, staticRenderFns } from "./ModalRemindBeforeSendRealFriendContact.vue?vue&type=template&id=0275c0fa&scoped=true"
import script from "./ModalRemindBeforeSendRealFriendContact.vue?vue&type=script&lang=js"
export * from "./ModalRemindBeforeSendRealFriendContact.vue?vue&type=script&lang=js"
import style0 from "./ModalRemindBeforeSendRealFriendContact.vue?vue&type=style&index=0&id=0275c0fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0275c0fa",
  null
  
)

export default component.exports